(ns teamoesterreich.user-mode.prevent.prevent-questionnaire-location-question
  (:require
    [clojure.string]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.info :refer [info]]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    [reagent-material-ui.icons.keyboard-arrow-right :refer [keyboard-arrow-right]]
    [reagent.core :as r]
    [teamoesterreich.firebase.fb-questionnaire-helper :as fq-helper]
    [teamoesterreich.store :as store]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.user-mode.prevent.location-answer-option :as ao]
    [teamoesterreich.user-mode.prevent.questionnaire-helper :as qn-helper]
    [teamoesterreich.user-mode.prevent.trigger-helper2 :as trigger-helper]
    [teamoesterreich.util.log :as log]
    ))





(defn get-it []
  (fn []
    (let [
          selected-questionnaire-cs (r/cursor store/app-state [:state :selected-questionnaire])
          questionnaireId @selected-questionnaire-cs
          questionnaire-cs (r/cursor store/app-state [:questionnaires questionnaireId])

          !selected-location (r/cursor store/app-state [:state :selected-location])

          selected-question-cs (r/cursor store/app-state [:state :selected-questionnaire-question])
          questionId @selected-question-cs
          question-cs (r/cursor questionnaire-cs [:questions questionId])
          question @question-cs

          questionnaire-response-cs (r/cursor store/app-state [:locations @!selected-location :questionnaires questionnaireId])
          question-response-cs (r/cursor store/app-state [:locations @!selected-location :questionnaires questionnaireId :questions questionId])
          _ (log/out "selected q " @selected-question-cs "->" (clj->js question))
          _ (log/out "qnn-answer? q " (clj->js (when questionnaire-response-cs @questionnaire-response-cs)))
          _ (log/out "q-answer? q " (clj->js (when question-response-cs @question-response-cs)))
          ]
      (log/debug "act-questionnaire " @selected-questionnaire-cs @questionnaire-cs)
      [mui/grid
       {:container  true
        :direction  "row"
        :justify    "center"
        :alignItems "stretch"
        :spacing    1
        }
       (trigger-helper/trigger-modal)
       [mui/grid
        {:container false
         :item      true
         :xs        12
         }
        [:br]
        [mui/typography {:variant "h5"} (:name @questionnaire-cs)]
        ]
       [mui/grid
        {:container false
         :item      true
         :lg        7
         :xs        11
         }

        [mui/card {:class-name "wrap-content-card"}
         (when (:imageUri question)
           [mui/card-media
            {:component "img"
             :image     (:imageUri question)
             :height    "400"
             :alt       (str "Bild " (:imageUri question))
             }])
         [mui/card-content
          [mui/typography {:variant "h5"} (:question question)
           (when (and (:long-description question) (> (count (clojure.string/trim (:long-description question))) 0))
             [mui/icon-button {:edge    "end"
                               :onClick #(a/set-page :questionnaire-info)
                               }
              [info]])]]
         [mui/typography {:variant "h6" :style {:textAlign "left" :padding "10px 40px 10px 50px"}} (:description question)
          [:br]
          (ao/answer-options @!selected-location questionnaireId questionId question-cs question-response-cs
                             (fn []
                               (log/out (str "question `" (:question question) "` answered!"))
                               (a/set-user-location-questionnaire-response @!selected-location questionnaireId
                                                                           {:last-change        (js/Date.)
                                                                            (keyword "#points") (fq-helper/calculate-location-questionnaires-question-sum @!selected-location questionnaireId)})
                               (a/set-user-location-questionnaire-question-response @!selected-location questionnaireId questionId {:last-change (js/Date.)})
                               ))

          ]



         [mui/card-actions
          [mui/grid
           {:container  true
            :direction  "row"
            :justify    "center"
            :alignItems "stretch"
            :spacing    1
            }

           [mui/grid
            {:container false
             :item      true
             :md        6
             :xs        12
             }
            [mui/button
             {:variant   "contained"
              :color     "default"
              :edge      "start"
              :class     "bottom-button"
              :onClick   (fn []
                           (if-let [new-uuid (qn-helper/get-backward-uuid @questionnaire-cs questionId)]
                             (reset! selected-question-cs new-uuid)
                             (a/set-page :questionnaire-location-intro)))
              :startIcon (r/as-element [keyboard-arrow-left])
              }
             (if (qn-helper/get-backward-uuid @questionnaire-cs questionId) "Vorher" "Zurück")]]
           [mui/grid
            {:container false
             :item      true
             :md        6
             :xs        12
             }

            [mui/button
             {:variant   "contained"
              :edge      "end"
              :color     "primary"
              :class     "bottom-button"
              :onClick   (fn []
                           (if-let [new-uuid (qn-helper/get-forward-uuid @questionnaire-cs questionId)]
                             (reset! selected-question-cs new-uuid)
                             (a/set-page :questionnaire-location-summary :questionnaire-location-question)))
              :startIcon (r/as-element [keyboard-arrow-right])
              }
             (if (qn-helper/get-forward-uuid @questionnaire-cs questionId) "Weiter" "Fertig")]]]
          ]

         ]]

       ]
      )))

